import {useCallback, useEffect, useState} from "react";
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import FileInput from '@uppy/file-input';
import {Endpoints, TFile} from "@brg/api";

export function createUppy(fileRef: any, handler: any) {
    // @ts-ignore
    return new Uppy().use(Tus, {
        endpoint: `${Endpoints.uploader}/upload/`,
        chunkSize: 4194304
    })
        .use(FileInput, {
            target: fileRef.current,
            id: 'fileRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
        .on('complete', (result: any) => {
            if (!!result?.successful?.length) {

                const results = result.successful.map((item: any, idx: any) => {
                    const url = item.uploadURL
                    const linkT = url.split('/')
                    const lngh = linkT.length - 1
                    const id = linkT[lngh];
                    const progress = item?.progress?.percentage;

                    return {
                        ...item,
                        progress,
                        url: id,
                        id
                    }

                })

                handler(results)
            }
        })
}

export const useUppyLoader = (files: TFile[], fileRef: any, handler: any, time: any) => {
    const [data, setData] = useState([]);
    const [src, setSrc] = useState<any>([]);
    const [images, setImages] = useState([]);
    const [uploadCompelete, setUploadCompelete] = useState(false);
    // @ts-ignore
    const onUploadComplete = useCallback((files) => {
        setImages(files);
        setUploadCompelete(true);
        handler(uploadCompelete);
    }, [images, uploadCompelete])

    const [uppy] = useState(() => createUppy(fileRef, onUploadComplete))

    useEffect(() => {
        if (files?.length) {
            // @ts-ignore
            const srcHere = [];
            uppy.reset();

            files.forEach((file: any, idx: number) => {
                const fr = new FileReader();
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    })
                } catch (err: any) {
                    if (err.isRestriction) {
                        // handle restrictions
                        console.error('Restriction error:', err)
                    } else {
                        // handle other errors
                        console.error(err)
                    }
                }

                fr.onload = () => {
                    srcHere.push({ name: file?.name, src: fr.result })
                }


                fr.readAsDataURL(file)
            })

            // @ts-ignore
            setSrc(srcHere)
            uppy.upload()
        }

    } , [files, uppy])

    useEffect(() => {
        if (images?.length) {
            // @ts-ignore
            setData(images?.map((img: any) => {
                const s = src?.find((s: any) => s.name === img.name);
                if (s) {
                    return {
                        ...img,
                        src: s?.src
                    }
                }
                return img
            }))
        }
    } , [src, images])

    useEffect(() => {
        setData([]);
    } , [time])

    return [uppy, data]
}import {useCallback, useEffect, useState} from "react";
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import FileInput from '@uppy/file-input';
import {Endpoints, TFile} from "@brg/api";

export function createUppy(fileRef: any, handler: any) {
    // @ts-ignore
    return new Uppy().use(Tus, {
        endpoint: `${Endpoints.uploader}/upload/`,
        chunkSize: 4194304
    })
        .use(FileInput, {
            target: fileRef.current,
            id: 'fileRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
        .on('complete', (result: any) => {
            if (!!result?.successful?.length) {

                const results = result.successful.map((item: any, idx: any) => {
                    const url = item.uploadURL
                    const linkT = url.split('/')
                    const lngh = linkT.length - 1
                    const id = linkT[lngh];
                    const progress = item?.progress?.percentage;

                    return {
                        ...item,
                        progress,
                        url: id,
                        id
                    }

                })

                handler(results)
            }
        })
}

export const useUppyLoader = (files: TFile[], fileRef: any, handler: any, time: any) => {
    const [data, setData] = useState([]);
    const [src, setSrc] = useState<any>([]);
    const [images, setImages] = useState([]);
    const [uploadCompelete, setUploadCompelete] = useState(false);
    // @ts-ignore
    const onUploadComplete = useCallback((files) => {
        setImages(files);
        setUploadCompelete(true);
        handler(uploadCompelete);
    }, [images, uploadCompelete])

    const [uppy] = useState(() => createUppy(fileRef, onUploadComplete))

    useEffect(() => {
        if (files?.length) {
            // @ts-ignore
            const srcHere = [];
            uppy.reset();

            files.forEach((file: any, idx: number) => {
                const fr = new FileReader();
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    })
                } catch (err: any) {
                    if (err.isRestriction) {
                        // handle restrictions
                        console.error('Restriction error:', err)
                    } else {
                        // handle other errors
                        console.error(err)
                    }
                }

                fr.onload = () => {
                    srcHere.push({ name: file?.name, src: fr.result })
                }


                fr.readAsDataURL(file)
            })

            // @ts-ignore
            setSrc(srcHere)
            uppy.upload()
        }

    } , [files, uppy])

    useEffect(() => {
        if (images?.length) {
            // @ts-ignore
            setData(images?.map((img: any) => {
                const s = src?.find((s: any) => s.name === img.name);
                if (s) {
                    return {
                        ...img,
                        src: s?.src
                    }
                }
                return img
            }))
        }
    } , [src, images])

    useEffect(() => {
        setData([]);
    } , [time])

    return [uppy, data]
}